module.exports = __webpack_public_path__ + "img/transformed.2b66b497.svg";